
import React from 'react';
import Notification from '../Notification/Notification';
import './NotificationManager.css';
import { useDispatch, useSelector } from 'react-redux';
import { removeNotification } from '../../store/notificationsSlice';
import { setSelectedConversationId } from '../../../../store/messagesSlice/messagesSlice';
import { setOpenModal } from '../../../ControlPanel/store/controlPanelSlice';
import useNotificationTriggers from './useNotificationTriggers';
import { SuperSpeakerNotification } from '../../../ControlPanel/components/Announcemant/SuperSpeakerNotification';

export default function NotificationManager() {
  const { isSuperSpeakerActive } = useSelector((state) => state.announcement);
  const dispatch = useDispatch()

  const { notifications } = useSelector(state => state.notifications)

  const onDismiss = (notificationId) => {
    dispatch(removeNotification(notificationId))
  }

  const onReply = (conversationId) => {
    dispatch(setSelectedConversationId(conversationId))
    dispatch(setOpenModal('message_history'))
  }

  useNotificationTriggers();

  const mockNotif = {
    id: 'conversation-dm_1148',
    type: 'message',
    variant: 'standard',
    message: {
      text: 'test',
      translate: false,
      variables: {}
    },
    sound: {
      url: 'iphone_message.mp3',
      volume: 1
    },
    options: {},
    user: {
      id: 1148,
      lastName: 'test',
      firstName: 'hama',
      urlphoto: 'Avatar.png',
      is_online: true
    },
    conversation: {
      id: 'dm_1148',
      unread_count: 1
    }
  }

  return (
    <>
     <div className="notifications-container"> 
      {isSuperSpeakerActive && <SuperSpeakerNotification />}
      {notifications.map((n) => (
        <Notification key={n.id} notification={n} onDismiss={onDismiss} onReply={onReply} />
      ))}
      {/*<Notification key={mockNotif.id} notification={mockNotif} />*/}
    </div>
    </>
  );
}